import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import { useState } from 'react';

import IconArrowUp from '~public/static/images/caretUp.svg';

import type { HeaderDropdownProps } from '../HeaderDropdown.types';
import styles from './HeaderDropdownMobile.module.scss';

export function HeaderDropdownMobile({
  items,
  className,
}: HeaderDropdownProps) {
  const [openIds, setOpenIds] = useState(new Set());

  const toggleDropdown = (id) => {
    setOpenIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  return (
    <div className={classNames(styles.accordionWrapper, className)}>
      {items.map((column) => {
        return (
          <>
            <div
              className={styles.accordion}
              onClick={() => toggleDropdown(column.id)}
            >
              <Typography
                className={styles.accordionTitle}
                tagName={TypographySizes.p}
                mods={[TypographyMods.bodyL]}
              >
                {column.title}
              </Typography>
              <IconArrowUp
                className={classNames(styles.iconArrow, {
                  [styles.open]: openIds.has(column.id),
                })}
              />
            </div>
            <div
              className={classNames(styles.accordionContent, {
                [styles.open]: openIds.has(column.id),
              })}
            >
              <div className={classNames(styles.accordionItems)}>
                {column.dropdown?.map((item) => {
                  return (
                    <a
                      key={item.id}
                      href={item.link?.href}
                      className={styles.accordionItem}
                    >
                      <div>
                        <Typography
                          tagName={TypographySizes.p}
                          mods={[TypographyMods.captionMAlt]}
                        >
                          {item.title}
                        </Typography>
                        {item.text && (
                          <Typography
                            tagName={TypographySizes.p}
                            mods={[TypographyMods.captionM]}
                            className={styles.subtitle}
                          >
                            {item.text}
                          </Typography>
                        )}
                      </div>
                    </a>
                  );
                }) ?? []}
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}
